import { cookieExists, createCookie, lockScroll, unlockScroll } from '../util/common';
import { newModalWithSelector } from '../components/modal';

class Multilanguage {
    init (condition) {
        var url = new URL(window.location.href);
        var showPopup = url.searchParams.get('showMultilanguage');
        if (condition === true) {
            showMultilanguagePopup(condition);
        }
        if ((!cookieExists('dw_subscribepopup')) || (showPopup)) {
            setTimeout(function () {
                showMultilanguagePopup(condition);
            });
        }
    }

    setCookie () {
        createCookie('dw_subscribepopup', '1', parseInt(window.Multilanguage.MultilanguagePopupExpiryDays));
    }

    showPopup () {
        showMultilanguagePopup();
    }
};

function showMultilanguagePopup (condition) {
    const url = window.Multilanguage.getMultilanguagePopup;
    unlockScroll();
    createCookie('dw_subscribepopup', '1', parseInt(window.SitePreferences.NewsletterPopupExpiryDays));
    if (url) {
        $.ajax({
            url: url,
            type: 'get',
            success: function (data) {
                if (!data.trim()) {
                    return;
                }
                // Create a modal
                if (condition === false) {
                    var modal = newModalWithSelector(data, false, ['multilanguage-popup'], null, data);
                    // Hide the pre-home and geoBlock
                    $('.content-asset').hide();
                    $('.cc-geoblock').hide();
                    modal.open();
                    $('.action-change.js-country-line').on('click', function (evt) {
                        const $target = $(evt.currentTarget);
                        const url = $target.data('href');
                        const locale = $target.data('locale');
                        const currency = $target.data('currency');

                        $.ajax({
                            url: url,
                            data: {
                                code: locale,
                                currency: currency,
                                queryString: $('.page').data('querystring'),
                                action: $('.page').data('action')
                            }
                        }).then(function (rsp) {
                            if (rsp.redirectUrl) {
                                document.location.href = rsp.redirectUrl;
                            }
                        });
                        modal.close();
                        $('.content-asset').show();
                        $('.cc-geoblock').show();
                        unlockScroll();
                    });
                    if (!Foundation.MediaQuery.atLeast('large')) {
                        lockScroll();
                    }
                }
            }
        });
    }
}

const multilanguagePopup = new Multilanguage();
export default multilanguagePopup;
